import AppConfig from "../../config";
import httpClient from "../../utils/http-client";
import BaseResponse from "../../models/common/BaseResponse";
import PagedListModel from "../../models/common/PagedListModel";
import CitySearchInputModel from "../../models/admin/city/request/CitySearchInputModel";
import CityResponseModel from "../../models/admin/city/response/CityResponseModel";
import CityRequestModel from "../../models/admin/city/request/CityRequestModel";

class CityService {
    async getCities(inputParms: CitySearchInputModel) {
        let res: PagedListModel<CityResponseModel> = await httpClient.post<PagedListModel<CityResponseModel>>(AppConfig.admin.city.getCities, inputParms);
        return res;
    };

    async getCityById(cityId: string) {
        let res: BaseResponse<CityResponseModel> = await httpClient.get<BaseResponse<CityResponseModel>>(AppConfig.admin.city.getCityById + "/" + cityId);
        return res;
    };

    async saveCity(city: CityRequestModel) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.admin.city.saveCity, city);
        return res;
    };
}
const cityService = new CityService();
export default cityService;